import { render, staticRenderFns } from "./effectDetailVideo.vue?vue&type=template&id=465d3294&scoped=true"
import script from "./effectDetailVideo.vue?vue&type=script&lang=js"
export * from "./effectDetailVideo.vue?vue&type=script&lang=js"
import style0 from "./effectDetailVideo.vue?vue&type=style&index=0&id=465d3294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d3294",
  null
  
)

export default component.exports